import { Route, Routes } from 'react-router-dom';
import { AuthProvider } from './lib/auth-context.js';
import { SettingsProvider } from './lib/settings-context.js';
import { AppearanceProvider } from './lib/appearance-context.js';
import { RequireAuth } from './lib/RequireAuth.js';
import { HomeRedirect } from './lib/HomeRedirect.js';
import { AppShell } from './layout/AppShell.js';
import { LoginPage } from './pages/LoginPage.js';
import { CustomersPage } from './pages/CustomersPage.js';
import { CustomerNewPage } from './pages/CustomerNewPage.js';
import { CustomerDetailPage } from './pages/CustomerDetailPage.js';
import { PalletDetailPage } from './pages/PalletDetailPage.js';
import { PartnersPage } from './pages/PartnersPage.js';
import { PartnerNewPage } from './pages/PartnerNewPage.js';
import { PartnerDetailPage } from './pages/PartnerDetailPage.js';
import { SkuDetailPage } from './pages/SkuDetailPage.js';
import { LowStockPage } from './pages/LowStockPage.js';
import { OrdersPage } from './pages/OrdersPage.js';
import { OrderNewPage } from './pages/OrderNewPage.js';
import { OrderDetailPage } from './pages/OrderDetailPage.js';
import { PasswordResetRequestPage } from './pages/PasswordResetRequestPage.js';
import { PasswordResetConfirmPage } from './pages/PasswordResetConfirmPage.js';
import { ReportsPage } from './pages/ReportsPage.js';
import { HolidaysPage } from './pages/HolidaysPage.js';
import { EmailTemplatesPage } from './pages/EmailTemplatesPage.js';
import { InvitationsPage } from './pages/InvitationsPage.js';
import { AcceptInvitePage } from './pages/AcceptInvitePage.js';
import { MyHomePage } from './pages/MyHomePage.js';
import { MyPalletsPage } from './pages/MyPalletsPage.js';
import { StockDashboardPage } from './pages/StockDashboardPage.js';
import { ShelfPage } from './pages/ShelfPage.js';
import { WarehouseLoadPage } from './pages/WarehouseLoadPage.js';
import { AdminHomePage } from './pages/AdminHomePage.js';
import { StaffAccessPage } from './pages/StaffAccessPage.js';
import { RbacMatrixPage } from './pages/RbacMatrixPage.js';
import { PricingTiersPage } from './pages/PricingTiersPage.js';
import { OrderNotificationSettingsPage } from './pages/OrderNotificationSettingsPage.js';
import { LowStockReportSettingsPage } from './pages/LowStockReportSettingsPage.js';
import { AppearanceSettingsPage } from './pages/AppearanceSettingsPage.js';

export function App() {
  return (
    <AuthProvider>
      <AppearanceProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/password-reset" element={<PasswordResetRequestPage />} />
          <Route path="/reset" element={<PasswordResetConfirmPage />} />
          <Route path="/accept-invite" element={<AcceptInvitePage />} />
          <Route
            element={
              <RequireAuth>
                <SettingsProvider>
                  <AppShell />
                </SettingsProvider>
              </RequireAuth>
            }
          >
            <Route index element={<HomeRedirect />} />
            <Route path="my" element={<MyHomePage />} />
            <Route path="my/pallets" element={<MyPalletsPage />} />
            <Route path="customers" element={<CustomersPage />} />
            <Route path="customers/new" element={<CustomerNewPage />} />
            <Route path="customers/:id" element={<CustomerDetailPage />} />
            <Route path="pallets/:id" element={<PalletDetailPage />} />
            <Route path="partners" element={<PartnersPage />} />
            <Route path="partners/new" element={<PartnerNewPage />} />
            <Route path="partners/:id" element={<PartnerDetailPage />} />
            <Route path="partners/:partnerId/low-stock" element={<LowStockPage />} />
            <Route path="partners/:partnerId/skus/:skuId" element={<SkuDetailPage />} />
            <Route path="orders" element={<OrdersPage />} />
            <Route path="orders/new" element={<OrderNewPage />} />
            <Route path="orders/:id" element={<OrderDetailPage />} />
            <Route path="stock" element={<StockDashboardPage />} />
            <Route path="shelf" element={<ShelfPage />} />
            <Route path="warehouse" element={<WarehouseLoadPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="settings/notifications" element={<OrderNotificationSettingsPage />} />
            <Route path="settings/appearance" element={<AppearanceSettingsPage />} />
            <Route path="admin" element={<AdminHomePage />} />
            <Route path="admin/staff-access" element={<StaffAccessPage />} />
            <Route path="admin/rbac" element={<RbacMatrixPage />} />
            <Route path="admin/pricing-tiers" element={<PricingTiersPage />} />
            <Route path="admin/holidays" element={<HolidaysPage />} />
            <Route path="admin/email-templates" element={<EmailTemplatesPage />} />
            <Route path="admin/invitations" element={<InvitationsPage />} />
            <Route path="admin/low-stock-report" element={<LowStockReportSettingsPage />} />
          </Route>
        </Routes>
      </AppearanceProvider>
    </AuthProvider>
  );
}
